import api from "../../utils/api/api.utils";
import { append } from "../../utils/api.utils";
export var getQuote = function (leadId, quoteId, publicId) {
    return api.get(append("/leads/".concat(leadId, "/quotes/").concat(quoteId), { publicId: publicId }, false));
};
export var createQuote = function (leadId, createdQuote, publicId) {
    return api.post(append("/leads/".concat(leadId, "/quotes"), { publicId: publicId }, false), { data: createdQuote });
};
export var resendToBaloise = function (leadId, quoteId) {
    return api.post("/leads/".concat(leadId, "/quotes/").concat(quoteId, "/resend-to-baloise"));
};
